const userKey = '_ssat'
const INITIAL_STATE = {
    user: JSON.parse(localStorage.getItem(userKey)),
    validToken: false,
    config: { usa_adaptativo: false }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TOKEN_VALIDATED':
            if (action.payload) {
                return { ...state, validToken: true }
            } else {
                localStorage.removeItem(userKey);
                localStorage.removeItem('_cfg');                
                return { ...state, validToken: false, user: null }
            }
        case 'USER_FETCHED':
            localStorage.setItem(userKey, JSON.stringify(action.payload));
            
            return { ...state, user: action.payload, validToken: true }
        case 'CLIENT_CONFIG_FETCHED':
            return { ...state, config: action.payload }
        default:
            return state
    }
}